import { render, staticRenderFns } from "./MissionContent.vue?vue&type=template&id=20bf1dd2&"
import script from "./MissionContent.vue?vue&type=script&lang=js&"
export * from "./MissionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports